import { render, staticRenderFns } from "./CheckboxForm.vue?vue&type=template&id=6426f1d8"
import script from "./CheckboxForm.vue?vue&type=script&lang=js"
export * from "./CheckboxForm.vue?vue&type=script&lang=js"
import style0 from "./CheckboxForm.vue?vue&type=style&index=0&id=6426f1d8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports